__turbopack_context__.v({
  "column": "ApplyFormImages-module__de-DkW__column",
  "columns": "ApplyFormImages-module__de-DkW__columns",
  "container": "ApplyFormImages-module__de-DkW__container",
  "fadeInItems": "ApplyFormImages-module__de-DkW__fadeInItems",
  "field": "ApplyFormImages-module__de-DkW__field",
  "fileInput": "ApplyFormImages-module__de-DkW__fileInput",
  "image": "ApplyFormImages-module__de-DkW__image",
  "imagePlaceholder": "ApplyFormImages-module__de-DkW__imagePlaceholder",
  "imageWrapper": "ApplyFormImages-module__de-DkW__imageWrapper",
  "inputIcon": "ApplyFormImages-module__de-DkW__inputIcon",
  "inputWrapper": "ApplyFormImages-module__de-DkW__inputWrapper",
  "spacing--lg": "ApplyFormImages-module__de-DkW__spacing--lg",
  "spacing--md": "ApplyFormImages-module__de-DkW__spacing--md",
  "spacing--sm": "ApplyFormImages-module__de-DkW__spacing--sm",
  "spacing--xl": "ApplyFormImages-module__de-DkW__spacing--xl",
  "spacing--xs": "ApplyFormImages-module__de-DkW__spacing--xs",
  "spacing--xxl": "ApplyFormImages-module__de-DkW__spacing--xxl",
  "spacing--xxs": "ApplyFormImages-module__de-DkW__spacing--xxs",
  "spacing--xxxl": "ApplyFormImages-module__de-DkW__spacing--xxxl",
  "spacing--xxxs": "ApplyFormImages-module__de-DkW__spacing--xxxs",
  "text": "ApplyFormImages-module__de-DkW__text",
  "title": "ApplyFormImages-module__de-DkW__title",
});
